// The shell every form control shares: label above, the control, helper or
// error text below. A control given none of the three renders bare, unless
// the caller asks for the shell regardless (Input always has one, so a bare
// input still takes the field's spacing).

export function FieldShell({
  id,
  label,
  help,
  error,
  className = '',
  style,
  always = false,
  children,
}) {
  if (!always && !label && !help && !error) return children
  return (
    <div className={`ui-field${className ? ` ${className}` : ''}`} style={style}>
      {label ? (
        <label className="label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      {children}
      {error ? (
        <span className="ui-field-error">{error}</span>
      ) : help ? (
        <span className="ui-field-help">{help}</span>
      ) : null}
    </div>
  )
}
